
import Layout from '../Components/Layout';
import { Route, Routes } from 'react-router-dom';
import Home from '../Pages/Home';
import About from '../Pages/About';
import Registration from '../Pages/Registration';
import Contact from '../Pages/Contact';
import Executives from '../Pages/Executives';
import Gallery from '../Pages/Gallery';
import MemberLogin from '../Pages/MemberLogin';
import MemberDashboard from '../Pages/MemberDashboard';
import Resources from '../Pages/Resources';

function ClientRoute() {
  return (
  <>
  <Layout>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/registration' element={<Registration />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/executives' element={<Executives />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/login' element={<MemberLogin />} />
          <Route path='/dashboard' element={<MemberDashboard />} />
          <Route path='/resources' element={<Resources />} />
        </Routes>
        </Layout>
        </>
  );
}

export default ClientRoute;
